<template>
  <div class="login">
    <a-row>
      <a-col class="login-col-left"></a-col>
      <a-col class="login-col-jumbotron">
        <div class="jumbotron">
          <!-- <div class="jumbotron-content"> -->
          <div class="jumbotron-content-title">悦享汽车生活</div>
          <!-- </div> -->
          <div class="jumbotron-image">
            <img class="jumbotron-image-bg"
                 src="../../../static/img/login.png"
                 alt="背景图">
          </div>
          <div class="jumbotron-content-text">优车享致力于构建汽车服务生态闭环，让人车生活更和谐</div>
        </div>
      </a-col>
      <a-col class="login-col-center"></a-col>
      <a-col class="login-col-form">
        <a-form @submit.prevent="doLogin"
                :autoFormCreate="(form) => this.form = form">
          <div class="form-title">
            <a-tabs class="ant-tabs-nav ant-tabs-tab-active"
                    default-active-key="1"
                    @change="loginTypeClick">
              <a-tab-pane key="1"
                          tab="邮箱登录"
                          force-render>
                <div v-if="!phoneLoginFlag">
                  <a-form-item fieldDecoratorId="email"
                               :fieldDecoratorOptions="{rules: [{ required: true, message: '请输入用户邮箱', whitespace: true}]}">
                    <a-input size="large"
                             placeholder="请输入您的用户邮箱">
                      <img class="input-icon"
                           slot="prefix"
                           src="../../../static/img/icon_person.png"
                           alt="">
                    </a-input>
                  </a-form-item>
                  <a-form-item fieldDecoratorId="password"
                               :fieldDecoratorOptions="{rules: [{ required: true, message: '请输入密码', whitespace: true}]}">
                    <a-input-password size="large"
                                      type="password"
                                      placeholder="请输入您的密码">
                      <img class="input-icon"
                           slot="prefix"
                           src="../../../static/img/icon_password.png"
                           alt="">
                    </a-input-password>
                  </a-form-item>
                </div>
              </a-tab-pane>
              <a-tab-pane key="2"
                          tab="手机号登录">
                <div v-if="phoneLoginFlag">
                  <a-form-item fieldDecoratorId="mobile"
                               :fieldDecoratorOptions="{rules: [{ required: true, message: '请输入手机号', whitespace: true}]}">
                    <a-input size="large"
                             placeholder="请输入您的手机号">
                      <img class="input-icon"
                           slot="prefix"
                           src="../../../static/img/icon_person.png"
                           alt="">
                    </a-input>
                  </a-form-item>
                  <a-form-item fieldDecoratorId="validCode"
                               :fieldDecoratorOptions="{rules: [{ required: true, message: '请输入验证码', whitespace: true}]}">
                    <a-input size="large"
                             placeholder="请输入验证码">
                      <img class="input-icon"
                           slot="prefix"
                           src="../../../static/img/icon_password.png"
                           alt="">
                      <div class="validCode"
                           slot="suffix">
                        <img class="validCode-image"
                             v-if="validCodeFlag"
                             src="validCodeUrl"
                             alt="验证码">
                        <span class="validCode-span"
                              :class="sendCaptchaFlag ? 'validCode-span-disabled' : ''"
                              v-else
                              @click="getCaptcha">{{sendCaptchaFlag ? validCodeTimeOut + '秒后重发' : '获取验证码'}}</span>
                      </div>
                    </a-input>
                  </a-form-item>
                </div>
              </a-tab-pane>
            </a-tabs>
          </div>
          <div v-if="phoneLoginFlag"></div>
          <div class="check-input"
               v-else>
            <a-checkbox style="width: 68%;"
                        @change="onChange"
                        v-model="rememberFlag"><span>记住本次登录状态</span></a-checkbox>
            <div class="other-input">
              <router-link style="color: #333333;"
                           to="/forget">忘记密码</router-link>
            </div>
          </div>
          <a-form-item class="submit-button">
            <a-button :loading="loading"
                      size="large"
                      htmlType="submit"
                      type="primary">
              登录
            </a-button>
          </a-form-item>
        </a-form>
      </a-col>
      <a-col class="login-col-right"></a-col>
    </a-row>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import setting from '../../settings.js'

export default {
  name: 'Login',
  data () {
    return {
      form: null,
      loading: false,
      error: '',
      activeKey: '1',
      rememberFlag: false,
      phoneLoginFlag: false,
      validCodeFlag: false,
      sendCaptchaFlag: false,
      submitSuccess: false,
      validCodeTimeOut: 60,
      validCodeUrl: '../../../static/img/icon_password.png',
      setting: setting
    }
  },
  computed: {
    systemName () {
      return this.$store.state.setting.systemName
    },
    copyright () {
      return this.$store.state.setting.copyright
    }
  },
  destroyed () {
    setTimeout(() => {
      if (this.submitSuccess) {
        document.getElementsByTagName('html')[0].style.fontSize = '14px'
      }
    }, 500)
  },
  mounted () {
    this.setFormValue()
  },
  methods: {
    setFormValue () {
      if (this.$cookies.isKey('email')) {
        this.form.setFieldsValue({
          email: this.$cookies.get('email')
        })
      }
      if (this.$cookies.isKey('rememberFlag')) {
        let cv = this.$cookies.get('rememberFlag')
        this.rememberFlag = cv && (cv === 'true')
      }
    },
    onChange (e) {
      this.rememberFlag = e.target.checked
    },
    doLogin () {
      this.form.validateFields(['email', 'password', 'mobile', 'validCode'], (errors, values) => {
        if (!errors) {
          this.loading = true
          if (this.phoneLoginFlag) {
            // 手机验证码登录
            let mobile = this.form.getFieldValue('mobile')
            let validCode = this.form.getFieldValue('validCode')
            this.$post('anon/login', {
              mobile: mobile,
              password: validCode
            }, true).then((r) => {
              let data = r.data.data
              this.saveLoginData(data)
              setTimeout(() => {
                this.loading = false
              }, 500)
              this.$router.push('/')
            }).catch(() => {
              setTimeout(() => {
                this.loading = false
              }, 500)
            })
          } else {
            // 用户邮箱密码登录
            let email = this.form.getFieldValue('email')
            let password = this.form.getFieldValue('password')
            this.$post('anon/login', {
              email: email,
              password: password
            }, true).then((r) => {
              this.submitSuccess = r.data.success
              if (r.data.success) {
                let data = r.data
                this.saveLoginData(data)
                setTimeout(() => {
                  this.loading = false
                }, 500)
                if (this.rememberFlag) {
                  this.$cookies.set('email', email, 60 * 60 * 24 * 30)
                  this.$cookies.set('rememberFlag', this.rememberFlag, 60 * 60 * 24 * 30)
                } else {
                  this.$cookies.remove('email')
                  this.$cookies.remove('rememberFlag')
                }
                this.$router.push('/')
              } else {
                this.$message.warning(r.data.message)
                setTimeout(() => {
                  this.loading = false
                }, 500)
              }
            }).catch(() => {
              setTimeout(() => {
                this.loading = false
              }, 500)
            })
          }
        }
      })
    },
    getCaptcha () {
      if (this.phoneLoginFlag && !this.sendCaptchaFlag) {
        this.form.validateFields(['mobile'], (errors, values) => {
          if (!errors) {
            // 获取验证码
            this.loading = true
            this.$post('anon/sendsms', {
              mobile: this.form.getFieldValue('mobile')
            }, true).then((r) => {
              if (r.data.success) {
                this.sendCaptchaFlag = true
                this.sendCaptchaTimeOut(this.validCodeTimeOut)
                this.$message.success(r.data.message)
              } else {
                this.$message.warning(r.data.message)
              }
              setTimeout(() => {
                this.loading = false
              }, 500)
            }).catch(() => {
              setTimeout(() => {
                this.loading = false
              }, 500)
            })
          }
        })
      }
    },
    loginTypeClick (activeKey) {
      this.phoneLoginFlag = (activeKey === '2')
    },
    sendCaptchaTimeOut (val) {
      let time = setInterval(() => {
        if (this.validCodeTimeOut === 0) {
          this.validCodeTimeOut = 60
          this.sendCaptchaFlag = false
          clearInterval(time)
        } else {
          this.validCodeTimeOut--
        }
      }, 1000)
    },
    ...mapMutations({
      setToken: 'account/setToken',
      setExpireTime: 'account/setExpireTime',
      setPermissions: 'account/setPermissions',
      setRoles: 'account/setRoles',
      setUser: 'account/setUser',
      setTheme: 'setting/setTheme',
      setLayout: 'setting/setLayout',
      setMultipage: 'setting/setMultipage',
      fixSiderbar: 'setting/fixSiderbar',
      fixHeader: 'setting/fixHeader',
      setColor: 'setting/setColor'
    }),
    saveLoginData (data) {
      this.setToken(data.token)
      this.setExpireTime(data.exipreTime)
      this.setUser(data.user)
      this.setPermissions(data.permissions)
      this.setRoles(data.roles)
      this.setTheme(data.config ? data.config.theme : 'dark')
      this.setLayout(data.config ? data.config.layout : 'side')
      this.setMultipage(data.config ? data.config.multiPage === '1' : false)
      this.fixSiderbar(data.config ? data.config.fixSiderbar === '1' : true)
      this.fixHeader(data.config ? data.config.fixHeader === '1' : false)
      this.setColor(data.config ? data.config.color : 'rgb(24, 144, 255)')
    }
  }
}
</script>

<style lang="less" scoped>
.login {
  height: calc(100vh - 8rem);
  min-height: 34rem;
  margin-top: 3rem;
  background-color: #f6f5fa;
  font-size: 1rem;
  font-family: "Source Han Sans CN";
  & > .ant-row {
    height: 100%;
    .ant-col {
      display: flex;
      height: 100%;
      align-items: center;
    }
    .jumbotron {
      width: 100%;
      margin-top: 15%;
      margin-left: 15%;
      &-content {
        position: relative;
        z-index: 1;
        &-title {
          margin-bottom: 6%;
          margin-left: 23%;
          color: #252b3a;
          font-size: 1.7rem;
          letter-spacing: 0.2rem;
          line-height: 1;
        }
        &-text {
          max-width: 30rem;
          color: #999999;
          font-size: 1rem;
          line-height: 3;
          margin-top: 6%;
        }
      }
      &-image {
        position: relative;
        z-index: 1;
        &-bg {
          width: 80%;
          margin-bottom: 6%;
        }
      }
    }
    form {
      position: relative;
      flex: 1;
      padding: 2.5rem 2.1rem;
      font-size: 1rem !important;
      background-color: #ffffff;
      z-index: 1;
      .form-title {
        position: relative;
        margin-bottom: 1.5rem;
        text-align: left;
        span {
          display: inline-block;
          color: #333333;
          line-height: 1;
          text-align: center;
        }
        &-img {
          position: absolute;
          top: -0.85rem;
          right: 0;
          width: 3.1rem;
          height: 3.1rem;
          cursor: pointer;
        }
      }
      /deep/ .ant-col {
        overflow: hidden;
      }
      /deep/ .ant-input,
      /deep/ .ant-select-selection {
        height: 2.2rem !important;
        background-color: #f8f8f8 !important;
        font-size: 0.8rem !important;
        line-height: 2.2rem !important;
      }
      /deep/ .ant-input-disabled {
        background-color: #f1f1f1 !important;
      }
      .form-company-img {
        position: relative;
        top: 1.5rem;
        left: 12px;
        width: 0.9rem;
        height: 0.9rem;
        z-index: 1;
      }
      /deep/ .ant-select-selection__rendered {
        height: 2.2rem !important;
        margin-left: 2rem !important;
        font-size: 0.8rem !important;
        line-height: 2.2rem !important;
        .ant-select-selection__placeholder {
          top: 45%;
        }
      }
      /deep/ .ant-input:hover {
        border-color: #eb6438 !important;
      }
      /deep/ .ant-input-suffix i {
        font-size: 0.8rem;
      }
      .input-icon {
        font-size: 0.8rem !important;
        width: 0.9rem;
        height: 0.9rem;
      }
      .validCode {
        display: inline-block;
        height: 2.2rem;
        padding: 0 1.2rem;
        color: #333333;
        font-size: 0.8rem !important;
        line-height: 2.2rem;
        &-span {
          display: inline-block;
          height: 2.2rem;
          cursor: pointer;
          line-height: 2.2rem;
          &:hover {
            color: #eb6438;
          }
        }
        &-span-disabled {
          color: #999999;
          cursor: unset;
          &:hover {
            color: #999999;
          }
        }
        .validCode-image {
          height: 2.2rem;
        }
      }
      /deep/ .ant-checkbox-wrapper {
        font-size: 0.7rem !important;
      }
      .ant-form-item {
        font-size: 0.5rem !important;
        margin-top: 0.1rem !important;
        margin-bottom: 1.7rem !important;
        /deep/ input.ant-input[type="text"],
        /deep/ input.ant-input[type="password"] {
          height: 2.2rem !important;
          border-radius: 0.02rem;
        }
        /deep/ .ant-form-item-control {
          line-height: 1.5 !important;
          .ant-input-affix-wrapper {
            height: 2.2rem;
            .ant-input-lg {
              padding: 0.3rem 2rem;
            }
          }
          .ant-form-explain {
            font-size: 0.8rem !important;
          }
        }
      }
      .check-input {
        margin-bottom: 1.2rem;
        width: 100%;
        .ant-checkbox {
          display: inline-block;
          transform: scale(calc(20 / 16 * 1rem / 20px));
          transform-origin: left center;
        }
      }
      .submit-button {
        margin-bottom: 0.9rem !important;
        button {
          width: 100%;
          height: 2.32rem;
          font-size: 0.9rem !important;
          border-radius: 0.02rem !important;
          background-color: #eb6438 !important;
          border: 0rem;
        }
      }
      .other-input {
        color: #333333;
        font-size: 0.7rem !important;
        width: 30%;
        text-align: right;
        display: inline-block;
        &-item {
          flex: 1;
          & > * {
            cursor: pointer;
          }
        }
        &-link {
          color: #333333;
        }
        &-loginType {
          text-align: right;
        }
      }
    }
  }
}
@media screen and (min-width: 1336px) {
  .login-col-left {
    float: left;
    width: 12.7%;
  }
  .login-col-jumbotron {
    float: left;
    width: 36.3%;
  }
  .login-col-center {
    float: left;
    width: 10.94%;
  }
  .login-col-form {
    float: left;
    width: 27.29%;
  }
  .login-col-right {
    float: left;
    width: 12.63%;
  }
}
@media screen and (max-width: 1336px) {
  .login-col-left {
    float: left;
    width: 7.7%;
  }
  .login-col-jumbotron {
    float: left;
    width: 43.3%;
  }
  .login-col-center {
    float: left;
    width: 7.94%;
  }
  .login-col-form {
    float: left;
    width: 33.29%;
  }
  .login-col-right {
    float: left;
    width: 7.63%;
  }
}
@media screen and (max-width: 1024px) {
  .login-col-left {
    display: none !important;
  }
  .login-col-jumbotron {
    display: none !important;
  }
  .login-col-center {
    display: none !important;
  }
  .login-col-form {
    width: 50%;
    margin: 0 25%;
  }
  .login-col-right {
    display: none !important;
  }
}
@media screen and (max-width: 768px) {
  .login-col-form {
    width: 80%;
    margin: 0 10%;
  }
}
.ant-tabs-nav.ant-tabs-tab-active {
  color: #eb6438;
  width: 100%;
}
.ant-tabs-ink-bar {
  color: #eb6438;
}
</style>



// WEBPACK FOOTER //
// Login.vue?019d11a8